module.exports = __webpack_public_path__ + "static/13-f36f627c7390654cb505f876267f273a.png";